import SuperRepository from '../superRepository'

export default new (class PartnerTagsRepository extends SuperRepository {
    baseUri() {
        return 'partner_tag'
    }
})()
